var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_166_1892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8334 9H13.3955C10.968 9 9 10.968 9 13.3955V19.8334C9 22.2609 10.968 24.2289 13.3955 24.2289H19.8334C22.2609 24.2289 24.2289 22.2609 24.2289 19.8334V13.3955C24.23 10.968 22.2619 9 19.8334 9ZM22.827 19.9467C22.827 21.5578 21.5211 22.8648 19.9089 22.8648H13.32C11.7089 22.8648 10.4019 21.5588 10.4019 19.9467V13.3588C10.4019 11.7477 11.7078 10.4407 13.32 10.4407H19.9089C21.52 10.4407 22.827 11.7466 22.827 13.3588V19.9477V19.9467Z",
    fill: "#9B9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6144 12.7009C14.4318 12.7009 12.6632 14.4706 12.6632 16.6521C12.6632 18.8337 14.4328 20.6033 16.6144 20.6033C18.796 20.6033 20.5656 18.8337 20.5656 16.6521C20.5656 14.4706 18.796 12.7009 16.6144 12.7009V12.7009ZM16.6144 19.2144C15.1996 19.2144 14.0532 18.067 14.0532 16.6532C14.0532 15.2394 15.2006 14.092 16.6144 14.092C18.0282 14.092 19.1756 15.2394 19.1756 16.6532C19.1756 18.067 18.0282 19.2144 16.6144 19.2144Z",
    fill: "#9B9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6984 13.472C21.207 13.472 21.6193 13.0597 21.6193 12.5511C21.6193 12.0424 21.207 11.6301 20.6984 11.6301C20.1898 11.6301 19.7775 12.0424 19.7775 12.5511C19.7775 13.0597 20.1898 13.472 20.6984 13.472Z",
    fill: "#9B9C9C"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.589286,
    y: 0.589286,
    width: 31.8214,
    height: 31.8214,
    rx: 15.9107,
    stroke: "#9B9C9C",
    strokeWidth: 1.17857
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_166_1892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.23,
    height: 15.23,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.ced4ca914165852ed8804ece3bb33fc5.svg";
export { ForwardRef as ReactComponent };